import script from "./ChatbotIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChatbotIcon.vue?vue&type=script&lang=ts&setup=true"

import _style_0 from "./ChatbotIcon.vue?vue&type=style&index=0&id=a6ac20ae&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['styles',[_style_0]],['__scopeId',"data-v-a6ac20ae"]])

export default __exports__